import { Link } from "react-router-dom";
import { useLocalePath, useT } from "../../i18n";
import { SITE_IMAGERY } from "../../config/siteImagery";
import { ResponsiveImage } from "../ResponsiveImage";
import { Reveal } from "../Reveal";
import { Phrases } from "../Phrases";

export const ExportSection = ({ index = "05" }) => {
  const t = useT();
  const lp = useLocalePath();
  const cols = [
    { title: t("export.japanTitle"), body: t("export.japanBody"), id: "japan" },
    { title: t("export.worldTitle"), body: t("export.worldBody"), id: "world" },
  ];
  return (
    <section data-testid="export-section" className="relative overflow-hidden bg-ink text-white">
      <ResponsiveImage image={SITE_IMAGERY.export} sizes="100vw" className="zoom-on-view absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-ink/70" aria-hidden />
      <div className="container-x relative flex min-h-[720px] flex-col justify-between gap-20 py-24 sm:py-32 lg:min-h-[860px] lg:py-40">
        <Reveal className="max-w-3xl">
          <p className="eyebrow flex items-center gap-4 text-white/60">
            <span className="tabular-nums">{index}</span>
            <span className="h-px w-8 bg-current" aria-hidden />
            {t("export.eyebrow")}
          </p>
          <h2 className="h-hero font-display mt-6" data-testid="export-title"><Phrases text={t("export.title")} /></h2>
        </Reveal>
        <div className="grid gap-10 md:grid-cols-12 md:items-start">
          {cols.map((c, i) => (
            <Reveal key={c.id} delay={i * 0.12} className="border-t border-white/25 pt-6 md:col-span-4">
              <div data-testid={`export-col-${c.id}`}>
                <p className="font-display text-3xl">{c.title}</p>
                <p className="mt-3 max-w-xs text-sm text-white/65">{c.body}</p>
              </div>
            </Reveal>
          ))}
          <Reveal delay={0.24} className="md:col-span-4 md:flex md:justify-end md:self-end">
            <Link to={lp("export")} className="btn btn-ghost-light" data-testid="export-cta">
              {t("export.cta")}
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
